module.exports = __webpack_public_path__ + "static/graph_en-1eca6f13d5d0d046db6baa2f8855fbee.jpg";